import { render } from "./monitoring.coreos.com.route.vue?vue&type=template&id=146ba6a2"
import script from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js"
export * from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js"

import "./monitoring.coreos.com.route.vue?vue&type=style&index=0&id=146ba6a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__